import { format } from "date-fns";
import { Button } from "../../components/Button";
import { FirstPost } from "./FirstPost";
import { postsList } from "../../../datasets/blog/postsList";
import background from "../../../assets/demyst_meta_image.png";
import Link from "next/link";

export const PostsList = ({ hasMore, isLoading, onLoadMoreClick, posts }) => {
  return (
    <section className="posts_list-background">
      <section className="section-layout">
        <section className="posts_list-main">
          <h1 className="posts_list-header">{postsList.head}</h1>
          {posts.length > 0 && (
            <>
              <FirstPost post={posts[0]} />
              <section className="posts_list-list">
                {posts
                  .filter((post, index) => index > 0)
                  .map(post => (
                    <div key={post.title} className="posts_list-post">
                      <Link href={new URL(post.url).pathname.replace("/<slug>", "")}>
                        <div
                          className="posts_list-image"
                          style={{
                            backgroundImage: `url(${
                              post?.featured_image ? post.featured_image : background
                            })`,
                          }}
                        />
                        <div className="posts_list-cover" />
                        <section className="posts_list-textarea">
                          <h2 className="posts_list-title">{post.title}</h2>
                          <p className="posts_list-description">{post.summary}</p>
                          <p className="posts_list-date">
                            {format(new Date(post.published), "LLLL dd, yyyy")}
                          </p>
                        </section>
                      </Link>
                    </div>
                  ))}
              </section>
            </>
          )}
          {isLoading && <span className="posts_list-spinner" />}
          {hasMore && (
            <h2>
              <Button onClick={onLoadMoreClick}>{postsList.button}</Button>
            </h2>
          )}
        </section>
      </section>
    </section>
  );
};
